import { UNSET_PSEUDO_DUID } from "./pseudoDuids";

export const UNSET_STATUS_PSEUDO_DUID = UNSET_PSEUDO_DUID;
export const UNSET_STATUS_LABEL = "(Unset)";
